module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/02-02.d7303dff.mp3";